(function () {
    'use strict';

    function deletePhaseModalController($scope, $uibModalInstance) {
        $scope.ok = function () {
            $uibModalInstance.close(true);
        };

        $scope.cancel = function() {
            $uibModalInstance.close();
        }
    }

    deletePhaseModalController.$inject = ['$scope', '$uibModalInstance'];

    angular.module('ecap.workflow').controller('deletePhaseModalController', deletePhaseModalController);
})();
